import React from 'react';

export const Button = ({ variant = 'primary', size = 'md', className = '', children, ...props }) => {
  let variantClass = '';
  let sizeClass = '';
  
  switch (variant) {
    case 'outline':
      variantClass = 'btn-outline-primary';
      break;
    case 'secondary':
      variantClass = 'btn-secondary';
      break;
    case 'success':
      variantClass = 'btn-success';
      break;
    case 'danger':
      variantClass = 'btn-danger';
      break;
    case 'warning':
      variantClass = 'btn-warning';
      break;
    case 'info':
      variantClass = 'btn-info';
      break;
    case 'light':
      variantClass = 'btn-light';
      break;
    case 'dark':
      variantClass = 'btn-dark';
      break;
    default:
      variantClass = 'btn-primary';
  }
  
  switch (size) {
    case 'sm':
      sizeClass = 'btn-sm';
      break;
    case 'lg':
      sizeClass = 'btn-lg';
      break;
    default:
      sizeClass = '';
  }
  
  return (
    <button className={`btn ${variantClass} ${sizeClass} ${className}`} {...props}>
      {children}
    </button>
  );
};